import { render, staticRenderFns } from "./ForteAch.vue?vue&type=template&id=caf0dfa4&scoped=true&"
import script from "./ForteAch.vue?vue&type=script&lang=js&"
export * from "./ForteAch.vue?vue&type=script&lang=js&"
import style0 from "./ForteAch.vue?vue&type=style&index=0&id=caf0dfa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf0dfa4",
  null
  
)

export default component.exports